import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Footer from '../../components/Footer/Footer'

import MainContainerAdhesion from '../../components/Carousel/MainContainerAdhesion'
import CardAdhesion from '../../components/Carousel/CardAdhesion'
import MainContainerAdhesion2 from '../../components/Carousel/MainContainerAdhesion2'
import HeaderAds from '../../components/Bar/HeaderAds'

const Adhesion = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
    
      <HeaderAds />
      <CardAdhesion />
      <MainContainerAdhesion />
      <MainContainerAdhesion2/>
     
      <Footer />
    </motion.div>
  )
}

export default Adhesion
